/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, ReactNode, useContext, useState } from 'react';

export interface AnimationContextType {
  animationIsRunning: boolean;
  setAnimationIsRunning: (isRunning: boolean) => void;
}

export const AnimationContext = createContext<AnimationContextType>({
  animationIsRunning: false,
  setAnimationIsRunning: () => {},
});

interface AnimationProviderProps {
  children: ReactNode;
}

export const AnimationProvider: React.FC<AnimationProviderProps> = ({ children }) => {
  const [animationIsRunning, setAnimationIsRunning] = useState<boolean>(false);

  return (
    <AnimationContext.Provider value={{ animationIsRunning, setAnimationIsRunning }}>
      {children}
    </AnimationContext.Provider>
  );
};

export const useAnimationContext = (): AnimationContextType => {
  const context = useContext(AnimationContext);
  if (!context) {
    throw new Error('useAnimation must be used within an AnimationProvider');
  }
  return context;
};
